// inclusive of 0 but not max
var getRandomInt = function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
};

export default getRandomInt;